import QuestionField from "./QuestionField";
import { isQuestionApplicable } from "../utils/questions";
import type { Answers, AnswerValue, Section } from "../types";

interface BriefingSectionProps {
  section: Section;
  answers: Answers;
  onChange: (questionId: string, value: AnswerValue) => void;
}

export default function BriefingSection({ section, answers, onChange }: BriefingSectionProps) {

  return (
    <section id={section.id} className="scroll-mt-28" style={{ minHeight: section.focus ? 320 : undefined }}>
      <div className="flex items-baseline gap-3 mb-1.5">
        <span className="text-xs font-bold text-abis-accent tabular-nums">{section.index}</span>
        <h2 className="text-xl md:text-2xl font-bold text-abis-primary">{section.title}</h2>
      </div>
      <p className="text-sm text-gray-600 mb-3">{section.description}</p>
      {/*
        Editorial aside — always rendered server-side, never collapsed (plan §5.1).
        It is the load-bearing AEO content: self-contained prose next to the
        question it explains, not a preamble the crawler has to connect back to it.
      */}
      <aside className="text-sm text-gray-700 bg-abis-primary/5 border-l-2 border-abis-primary/30 rounded-r-lg px-4 py-3 mb-6 leading-relaxed">
        {section.aside}
      </aside>
      {section.note ? (
        <p className="text-xs text-abis-neutral bg-gray-50 border border-gray-200 rounded-lg px-3.5 py-2.5 mb-6">
          {section.note}
        </p>
      ) : null}

      <div>
        {section.questions.map((question) => (
          <QuestionField
            key={question.id}
            question={question}
            value={answers[question.id]}
            onChange={(value) => onChange(question.id, value)}
            hidden={!isQuestionApplicable(question, answers)}
          />
        ))}
      </div>
    </section>
  );
}
